var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.col-md {\n  margin-right: 0%;\n}\n.rowBackgroundImage {\n  background-image: url(" + escape(require("../../assets/static/images/MenuFont.png")) + ");\n  background-size: contain;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-26ccf1d4","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/bankAccounts/CMListStatementBankAccount.vue
// module id = 1117
// module chunks = 2